import { type QueryHookOptions, useQuery } from "@apollo/client";
import { LinksAutocompleteQuery } from "../graphql/queries";
import type {
  LinksAutocompleteQueryType,
  LinksAutocompleteQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useLinksAutocompleteQuery = (
  options?: QueryHookOptions<
    LinksAutocompleteQueryType,
    LinksAutocompleteQueryVariablesType
  >
) => {
  return useQuery<
    LinksAutocompleteQueryType,
    LinksAutocompleteQueryVariablesType
  >(LinksAutocompleteQuery, options);
};
